require('angular').module('wowApp.common')
    .service('EDRCardLinkingService', ['PopupWindowService', 'RewardsCardService', require('./edrcard-linking-service')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/edrcardlinking/index.js
 **/